export default "__VITE_ASSET__BzfTH4zA__"